import { EntityQuery, FilterQueryOp } from 'breeze-client';
import { PbiReport } from '../../models';

const baseQuery = EntityQuery.from('PbiReports');

const selectWithReport = baseQuery.expand(PbiReport.propName('report'));
const selectDrafts = baseQuery
  .where(PbiReport.propName('isDraft'), FilterQueryOp.Equals, true)
  .orderBy(PbiReport.propName('createdDate') + ' desc');

const selectAskAgoraReports = baseQuery
  .where(PbiReport.propName('isDraft'), FilterQueryOp.Equals, false)
  .where(PbiReport.propPath('report', 'category'), FilterQueryOp.NotEquals, null)
  .where(PbiReport.propPath('report', 'isPublished'), FilterQueryOp.Equals, true)
  .select([
    PbiReport.propName('pbiDatasetId'),
    PbiReport.propName('reportId'),
    PbiReport.propPath('report', 'organisationWorkspace', 'templateWorkspace', 'name'),
    PbiReport.propPath('report', 'category')
  ])
  //to favour custom reports over standard if not hiding
  //and show only the oldest report if multiple reports in same category
  .orderBy([
    PbiReport.propPath('report', 'category'),
    PbiReport.propPath('report', 'isCustom'),
    PbiReport.propPath('report', 'createdDate')
  ]);

export const pbiReportQueries = {
  selectAll: baseQuery,
  selectDrafts,
  selectWithReport,
  selectAskAgoraReports
};
